import React, { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Button from '../components/common/Button'
import Icon from '../components/common/Icon'
import logo from '../logo-red.svg'
import { useAuth } from '../context/AuthContext'

let BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000'

const loginUrl =
  BASE_URL + (BASE_URL === 'http://localhost:8000' ? '/login' : '/api/login')

const navigateToLogin = () => {
  window.location.href = loginUrl
}

const LoginPage: React.FC = () => {
  const { user, login } = useAuth()
  const navigate = useNavigate()
  const initializedRef = useRef(false)

  if (user) {
    navigate('/chat')
  }

  const urlParams = new URLSearchParams(window.location.search)
  const codeParam = urlParams.get('code')

  const [isLoading, setIsLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState<string>()

  const handleLogin = async () => {
    setIsLoading(true)
    navigateToLogin()
  }

  const handleAuthCode = async () => {
    if (!codeParam) return

    setIsLoading(true)

    try {
      await login(codeParam)
    } catch (error: any) {
      console.error('Error during login:', error)
      // Extract detailed error message if available
      let errorMsg = 'Authentication failed: ' + error.message

      setErrorMessage(errorMsg)
      setErrorMessage('Error while logging in')

      // Reset button text after delay
      setTimeout(() => setErrorMessage(undefined), 6000)
    } finally {
      setIsLoading(false)
      // setBtnText('Login')
    }
  }

  useEffect(() => {
    // Use ref instead of state to ensure the code only runs once
    console.log('initializedRef', initializedRef.current)
    if (!initializedRef.current) {
      console.log('Running auth code check...')
      handleAuthCode()
      initializedRef.current = true
    }
  }, [])
  return (
    <div className="login-page">
      <div className="login-page__container">
        <div className="login-page__logo">
          <img src={logo} alt="BreadGPT" />
        </div>
        <h1 className="login-page__title">Welcome to BreadGPT</h1>
        <p className="login-page__subtitle">Sign in to continue to BreadGPT</p>

        <div className="login-page__form">
          <Button
            variant="login"
            onClick={handleLogin}
            className="btn--primary"
            disabled={isLoading || !!codeParam}
          >
            <Icon name="microsoft" size={18} />
            Continue with Microsoft
          </Button>
        </div>
      </div>
    </div>
  )
}

export default LoginPage
